<template>
  <button class="definition-node"
    :class="[{
      'selected': isSelected,
      'in-group': inGroup,
      'is-first': isFirst,
      'is-last': isLast,
      'is-removed': attribute.removed,
      'cant-drop-here': !canDropHere,
    }, levelClass]"
    :disabled="disableDefinitionPart"
    :key="attribute.definitionId"
    @click="clickHandler"
    @dblclick="editAttribute($event)"
    v-html="displayName"
    :draggable="isDraggable && !thisPartIsInACountGroup"
    @dragstart="dragStartHandler"
    @dragover="dragOverHandler"
    @dragleave="dragLeaveHandler"
    @drop="dropHandler"
    @dragend="dragEndHandler"
    @mouseover="showUEHoverOver"
    @mouseout="hideUEHoverOver"
  >
  </button>
</template>

<script>
  // TODO have to have the conifg attributeTypes in a common area
  import types from '@/appComponents/workbench/attributePanel/services/attributeType'
  import { commaFormatString, createDisplayName } from '@/helpers'
  import { UPDATE_ATTRIBUTE } from '@/appComponents/workbench/targetDefinition/store/actions'
  import { createPopover, popoverTypes } from '@/components/common/popover'
  import SelectableMixin from './SelectableMixin'
  import DragAndDropHandlers from '../mixins/DragAndDropHandlers'
  const { BOOLEAN } = types
  import { definitionPartTypes } from '../../store/mutations'
  import HoverOver from '../mixins/HoverOver'

  export default {
    mixins: [
      SelectableMixin,
      DragAndDropHandlers,
      HoverOver
    ],
    props: {
      inGroup: {
        type: Boolean,
        default: false
      },
      isFirst: {
        type: Boolean,
        default: false
      },
      isLast: {
        type: Boolean,
        default: false
      },
      level: {
        type: Number,
        default: 0
      },
      definitionId: {
        type: String
      }
    },
    data () {
      return {
        defType: definitionPartTypes.ATTRIBUTE,
        hoverOverPopover: null
      }
    },
    computed: {
      displayName () {
        return createDisplayName(this.attribute)
      },
      disableDefinitionPart () {
        // TODO: remove hook to store
        let disabled = this.$store.getters['workbench/disableDefinitionPart']
        return disabled ? disabled(this.definitionId) : false
      },
      isRemoved () {
        return this.attribute.removed
      },
      levelClass () {
        return `level-${this.level}`
      },
      thisPartIsInACountGroup () {
        let inCountGroup = this.$store.getters['workbench/isInACountGroup']
        return inCountGroup ? inCountGroup(this.definitionId) : false
      },
      hoverOverMessage () {
        let ue = this.hasHoverOverMessage ? commaFormatString(Math.floor(Number(this.attribute.ue))) : 'NO DATA'
        return `${this.attribute.name} - UE : ${ue}`
      },
      hasHoverOverMessage () {
        return this.attribute.ue || this.attribute.ue === 0
      }
    },
    methods: {
      clickHandler () {
        if (this.thisPartIsInACountGroup) return
        this.select(this.attribute)
      },
      updateAttribute (updatedAttribute) {
        // TODO: remove hook to store
        this.$store.dispatch('workbench/' + UPDATE_ATTRIBUTE, {attribute: this.attribute, update: updatedAttribute})
      },
      editAttribute (e) {
        if (this.attribute.type === BOOLEAN || this.disabled) return
        this.popover = createPopover({
          direction: 'top',
          attribute: this.attribute,
          parent: e.target,
          root: document.getElementById('app'),
          type: popoverTypes.ATTRIBUTE
        })
        this.popover.$on('select', attr => {
          this.updateAttribute(attr)
        })
      }
    }
  }

</script>

<style lang="scss">
  .definition-node {
    position: relative;
    $border-radius: rem(15);

    flex-shrink: 0;
    flex-grow: 0;
    box-sizing: border-box;
    color: white;
    height: rem(30);
    padding: 0 rem(30);
    border-radius: rem(15);
    border: rem(2) solid color(grays, medium);
    margin-top: rem(5);
    margin-bottom: rem(5);

    &.level-0 {
      background-color: color(grays, medium);
      border-color: color(grays, medium);

      &:hover {
        $bg-color: lighten(color(grays, medium), 5%);
        background-color: $bg-color;
        border-color: $bg-color;
      }
    }

    &.level-1 {
      background-color: color(target, level-1-dark);
      border-color: color(target, level-1-dark);

      &:hover {
        $bg-color: lighten(color(target, level-1-dark), 5%);
        background-color: $bg-color;
        border-color: $bg-color;
      }
    }

    &.level-2 {
      background-color: color(target, level-2-dark);
      border-color: color(target, level-2-dark);

      &:hover {
        $bg-color: lighten(color(target, level-2-dark), 5%);
        background-color: $bg-color;
        border-color: $bg-color;
      }
    }

    &:focus {
      outline: none;
    }

    &:disabled:hover {
      background-color: color(grays, medium);
      border-color: color(grays, medium);
    }

    &.in-group {
      border-radius: 0;
      margin-left: -$border-radius;
      margin-right: -$border-radius;

      &.is-first {
        margin-left: 0;
        border-top-left-radius: $border-radius;
        border-bottom-left-radius: $border-radius;
      }

      &.is-last {
        margin-right: 0;
        border-top-right-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
      }
    }

    &.is-removed, &.is-removed:hover {
      background: color(red);
      border-color: color(red);
    }

    &.selected {
      &, &:hover {
        border-color: color(yellow);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DefinitionNode.vue?34e7f260